import { render, staticRenderFns } from "./Cartao.vue?vue&type=template&id=143722f5&scoped=true"
import script from "./Cartao.vue?vue&type=script&lang=js"
export * from "./Cartao.vue?vue&type=script&lang=js"
import style0 from "./Cartao.vue?vue&type=style&index=0&id=143722f5&prod&scoped=true&lang=css"
import style1 from "./Cartao.vue?vue&type=style&index=1&id=143722f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143722f5",
  null
  
)

export default component.exports